var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactJsTechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5CA4DA;}\r\n\t.st1{fill:#6DAFE0;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,45H4.8C2.1,45,0,42.9,0,40.2V4.8C0,2.1,2.1,0,4.8,0h35.4C42.9,0,45,2.1,45,4.8v35.4 C45,42.9,42.9,45,40.2,45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,0c-1.7,7.3-6,15.2-12.8,21.9C16.3,29.1,7.7,33.6,0,35V4.8C0,2.1,2.1,0,4.8,0H36.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.8,19.5c2.3-3.9,3.1-7.6,1.1-9.4c-2-2-5.5-1.1-9.4,1.1c-2.3-3.9-4.9-6.5-7.6-5.8s-3.7,4.2-3.7,8.7 c-4.5,0-8,1.1-8.7,3.7c-0.7,2.7,1.8,5.3,5.8,7.6C9,29.4,8.2,33,10.1,34.9c2,2,5.5,1.1,9.4-1.1c2.3,3.9,4.9,6.5,7.6,5.8 c2.7-0.7,3.7-4.2,3.7-8.7c4.5,0,8-1.1,8.7-3.7C40.2,24.5,37.7,21.8,33.8,19.5z M33.5,11.5c0.8,0.8,0.4,3.5-1.5,6.9 c-1.1-0.6-2.4-1.1-3.8-1.5c-0.4-1.3-1-2.5-1.5-3.8C30,11.1,32.5,10.7,33.5,11.5z M23.9,27.8c-2-0.4-3.5-0.8-5.3-1.4 c-0.6-1.8-1-3.4-1.4-5.3c1.3-1.4,2.4-2.5,3.9-3.9c2,0.4,3.5,0.8,5.3,1.4c0.6,1.8,1,3.4,1.4,5.3C26.6,25.5,25.5,26.6,23.9,27.8z  M28.3,26.7c0.1,0.6,0.1,1.3,0.1,1.8c-0.6,0-1.1-0.1-1.8-0.1C27.4,27.6,27.6,27.4,28.3,26.7z M21.8,29.7c-0.6,0.4-1,0.7-1.4,1.1 c-0.3-0.6-0.6-1.1-0.7-1.7C20.7,29.2,20.7,29.4,21.8,29.7z M16,25.5c-0.6-0.3-1.1-0.4-1.7-0.7c0.3-0.4,0.7-1,1.1-1.4 C15.6,24.3,15.8,24.3,16,25.5z M16.7,18.3c-0.1-0.6-0.1-1.3-0.1-1.8c0.6,0,1.1,0.1,1.8,0.1C17.6,17.4,17.4,17.6,16.7,18.3z  M23.2,15.3c0.6-0.4,1-0.7,1.4-1.1c0.3,0.6,0.6,1.1,0.7,1.7C24.3,15.8,24.3,15.6,23.2,15.3z M29,19.5c0.6,0.3,1.1,0.4,1.7,0.7 c-0.3,0.4-0.7,1-1.1,1.4C29.4,20.7,29.3,20.7,29,19.5z M18.6,7.6c1.1-0.3,3.2,1.4,5.2,4.8c-1.1,0.7-2.1,1.5-3.2,2.4 c-1.4-0.3-2.7-0.4-4.1-0.6C16.5,10.4,17.3,7.9,18.6,7.6z M7.6,18.6c0.3-1.1,2.8-2.1,6.8-2.1c0.1,1.3,0.3,2.7,0.6,4.1 c-0.8,1.1-1.7,2.1-2.4,3.2C9,21.7,7.3,19.7,7.6,18.6z M11.5,33.5c-0.8-0.8-0.4-3.5,1.5-6.9c1.1,0.6,2.4,1.1,3.8,1.5 c0.4,1.3,1,2.5,1.5,3.8C15,33.9,12.5,34.3,11.5,33.5z M26.4,37.4c-1.1,0.3-3.2-1.4-5.2-4.8c1.1-0.7,2.1-1.5,3.2-2.4 c1.4,0.3,2.7,0.4,4.1,0.6C28.5,34.6,27.7,37.1,26.4,37.4z M37.4,26.4c-0.3,1.1-2.8,2.1-6.8,2.1c-0.1-1.3-0.3-2.7-0.6-4.1 c0.8-1.1,1.7-2.1,2.4-3.2C36,23.3,37.7,25.3,37.4,26.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 22.5,
    cy: 22.5,
    r: 3.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactJsTechIcon);
export default __webpack_public_path__ + "static/media/react-js-tech-icon.747977be781c42dab5ae7849539d259d.svg";
export { ForwardRef as ReactComponent };